import { createSelector } from '@reduxjs/toolkit';
import { takesDataWithRelationsSelector } from 'app/store/selectors/takes';
import { reduxAssetsDataSelector } from 'app/store/selectors/assets';
import { allActivitiesSelector } from 'app/store/selectors/reduxActivities';
export const tasksReducer = (state) => state.reduxTasks;
export const tasksByTableSelector = (tableId) => { var _a; return (_a = createSelector(tasksReducer, (selector) => selector.tasksByTable[tableId])) !== null && _a !== void 0 ? _a : {}; };
export const tasksByTableDataSelector = (tableId) => createSelector(tasksReducer, (selector) => { var _a; return (_a = selector.tasksByTable[tableId]) === null || _a === void 0 ? void 0 : _a.data; });
export const relatedTasksDataSelector = createSelector(tasksReducer, (selector) => selector.relatedTasks.data);
export const allTasksByTableWithRelationsSelector = (tableId) => createSelector([tasksByTableDataSelector(tableId), takesDataWithRelationsSelector, reduxAssetsDataSelector, allActivitiesSelector], (tasks = [], takes, reduxAssets, activities) => {
    const taskWithRelatedTakes = tasks.map((task) => {
        const relatedTakes = takes.filter((take) => take.task === task.id);
        const relatedAssetInst = reduxAssets.find((asset) => asset.id === task.asset);
        const relatedActivities = activities.filter((activity) => activity.task === task.id);
        return Object.assign(Object.assign({}, task), { takesInst: relatedTakes, assetInst: relatedAssetInst, activitiesInst: relatedActivities });
    });
    return taskWithRelatedTakes;
});
export const flattenAllTakesByTableFromTasksSelector = (tableId) => createSelector([allTasksByTableWithRelationsSelector(tableId)], (tasks = []) => {
    const formattedData = tasks.flatMap((task) => {
        return task.takesInst.flatMap((take) => (Object.assign(Object.assign({}, take), { taskInst: task })));
    });
    return formattedData !== null && formattedData !== void 0 ? formattedData : [];
});
